import { HighlightIcon } from '@dev-spendesk/grapes';
import React from 'react';

import { SupplierLogo } from 'src/core/common/components/SupplierLogo';
import { useTranslation } from 'src/core/common/hooks/useTranslation';

import { type AccountPayableSuppliersRow } from '../../types';

type Props = {
  supplierNames: string[];
} & Pick<AccountPayableSuppliersRow, 'totalCount'>;

export const AccountPayableSuppliersNameCell = ({
  supplierNames,
  totalCount,
}: Props) => {
  const { t } = useTranslation('global');

  const borderClassNames =
    'rounded-8 border border-solid border-[white] bg-background-secondary-brand-default';

  return (
    <div className="flex items-center">
      {totalCount === 0 && (
        <HighlightIcon
          variant="info"
          name="circle-information"
          size={32}
          className="mr-8 shrink-0"
        />
      )}
      {totalCount > 0 && (
        <SupplierLogo
          name={supplierNames[0]}
          size={32}
          lazyLoad
          className={`z-[1] mr-8 ${borderClassNames}`}
        />
      )}
      {totalCount > 1 && (
        <SupplierLogo
          name={supplierNames[1]}
          size={32}
          lazyLoad
          className={`bottom-4 right-32 -mr-24 ${borderClassNames}`}
        />
      )}
      {totalCount === 0 && (
        <span className="truncate">
          {t('bookkeep.accountsPayable.list.noSupplier')}
        </span>
      )}
      {totalCount === 1 && <span className="truncate">{supplierNames[0]}</span>}
      {totalCount > 1 && (
        <span className="truncate">
          {t('bookkeep.accountsPayable.list.multipleSuppliers', {
            count: totalCount,
          })}
        </span>
      )}
    </div>
  );
};
